// =============================================================================
// src/features/analytics/analytics-rerender.ts - Re-render da rota Analytics.
//
// 2026-09-02: trocar escopo/periodo re-hidrata o store e a pagina INTEIRA e
// remontada a partir dos getters (o markup e render-time), preservando o estado
// da rota (aberta/fechada) e devolvendo ao chamador o momento de religar os
// listeners (a pagina antiga sai do DOM — sem listener duplicado). SRP: so DOM.
// =============================================================================

import { qs } from '../../app/dom';
import { buildAnalyticsPageMarkup } from './analytics-markup';
import { AnalyticsRoute } from './analytics-route';

/**
 * Remonta #u-analytics-page e chama `rebind` com o DOM novo no lugar.
 * Devolve false (sem tocar nada) quando a pagina nao esta montada.
 *
 * @example rerenderAnalyticsPage(() => initAnalyticsInteractions('analysis'));
 */
export function rerenderAnalyticsPage(rebind: () => void): boolean {
  const pageEl = qs<HTMLElement>('#u-analytics-page');
  if (!pageEl) return false;
  const wasOpen = AnalyticsRoute.isOpen();
  pageEl.outerHTML = buildAnalyticsPageMarkup();
  AnalyticsRoute.init();
  if (wasOpen) qs<HTMLElement>('#u-analytics-page')?.setAttribute('aria-hidden', 'false');
  rebind();
  return true;
}

/** Marca a pagina como ocupada durante a re-hidratacao (chips travados). */
export function setAnalyticsPageBusy(isBusy: boolean): void {
  const pageEl = qs<HTMLElement>('#u-analytics-page');
  if (!pageEl) return;
  pageEl.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  pageEl.classList.toggle('is-rehydrating', isBusy);
}
